import React from "react";
import Banner from '../comman/Banner/Banner';
import Aboutdasmesh from "../components/Aboutus/Aboutdsamesh"; 
// import Abouthistory from "../components/Aboutus/Ourhistory"; 


const Aboutdasmeshowner = () => {
  return (
    <>
    <Banner 
     index={'about'}
    />
    <Aboutdasmesh/> 
    {/* <Abouthistory/>         */}
    </>

  )
};

export default Aboutdasmeshowner;